import { render } from "./Skill.vue?vue&type=template&id=71145aeb&ts=true"
import script from "./Skill.vue?vue&type=script&lang=ts"
export * from "./Skill.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Karol\\Documents\\Github\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__